import { useEffect, useState } from "react";

const SIGNUP_URL = "https://mycouponbook.ca/signup/form";

const rotatingTexts = [
  "Build Loyalty",
  "Clear Inventory",
  "Drive Foot Traffic",
  "Attract Locals",
  "Boost Revenue",
];

const DealRedeemedCard = () => (
  <div className="w-[230px] sm:w-[290px] lg:w-[324px] rounded-[20px] lg:rounded-[24px] overflow-hidden border-[1.5px] border-white/80 bg-[rgba(90,10,10,0.55)] backdrop-blur-md shadow-[0_30px_60px_rgba(0,0,0,0.35)] animate-heroFloat">
    <div className="flex items-center gap-[12px] px-[16px] lg:px-5 py-[12px]">
      <span className="flex items-center justify-center w-[26px] h-[26px] lg:w-[32px] lg:h-[32px] rounded-full bg-[#D90000] text-white text-[11px] lg:text-[13px] font-medium">
        CB
      </span>
      <span className="text-white text-[15px] lg:text-[18px]">Café Bliss</span>
    </div>
    <div className="flex items-center justify-between gap-[12px] px-[16px] lg:px-5 py-[16px] rounded-[18px] bg-[linear-gradient(135deg,#E00000_0%,#B00000_60%,#8A0000_100%)] text-white">
      <div>
        <div className="text-[13px] lg:text-[17px]">Deal Redeemed</div>
        <div className="text-[22px] lg:text-[30px] leading-tight mt-[4px]">20% Off</div>
        <div className="text-[12px] lg:text-[15px] opacity-90 mt-[4px]">Your Order</div>
      </div>
      <div className="flex items-center gap-[8px] bg-white text-[#222] rounded-full px-[12px] py-1.5 lg:px-4 lg:py-2">
        <span className="flex items-center justify-center w-[18px] h-[18px] lg:w-[22px] lg:h-[22px] rounded-full bg-[#D90000]">
          <img src="/images/vector-7.svg" alt="" className="w-[9px] lg:w-[11px]" />
        </span>
        <span className="text-[12px] lg:text-[16px]">Verified</span>
      </div>
    </div>
  </div>
);

export const BusinessHeroSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % rotatingTexts.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative w-full overflow-hidden bg-[#1b120d] flex items-center min-h-[100svh] lg:min-h-[max(100vh,860px)]">
      <img
        src="/images/Webp/business/BusinessHeroBg.webp"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(0,0,0,0.45)_0%,rgba(0,0,0,0.15)_50%,rgba(0,0,0,0)_100%)]" />

      <div className="relative z-10 mx-auto w-full max-w-[1620px] px-[16px] sm:px-6 lg:px-[80px] pt-[120px] pb-16 lg:pt-[150px] lg:pb-[90px] grid grid-cols-1 lg:grid-cols-2 items-center gap-10 lg:gap-6">
        {/* LEFT */}
        <div className="max-lg:text-center">
          <div className="inline-flex items-center gap-[12px] px-[20px] py-2.5 lg:px-6 lg:py-3 rounded-full bg-white/20 backdrop-blur-md border-[1px] border-white/20">
            <span className="w-3 h-3 rounded-full bg-[#E00000] shadow-[0_0_10px_rgba(255,0,0,0.8)]" />
            <span className="text-white text-[14px] lg:text-[20px]">Trusted by 500+ Local Businesses</span>
          </div>

          <h1
            className="mt-8 lg:mt-10 text-white font-normal leading-[1.2] tracking-[-1px]"
            style={{ fontSize: "clamp(38px, 4.3vw, 82px)" }}
          >
            The Marketing
            <br className="hidden sm:block" /> Platform Built to
          </h1>

          <div className="overflow-hidden" style={{ height: "clamp(52px, 5.4vw, 104px)" }}>
            <div
              className="transition-transform duration-500"
              style={{ transform: `translateY(-${currentIndex * 100}%)`, height: "100%" }}
            >
              {rotatingTexts.map((text) => (
                <div
                  key={text}
                  className="h-full flex items-center justify-center lg:justify-start font-semibold text-[#FF1A1A] whitespace-nowrap tracking-[-1px]"
                  style={{ fontSize: "clamp(38px, 4.3vw, 82px)" }}
                >
                  {text}
                </div>
              ))}
            </div>
          </div>

          <p className="mt-6 lg:mt-8 max-lg:mx-auto max-w-[660px] text-white/90 text-[15px] sm:text-[18px] lg:text-[26px] leading-[1.4]">
            Connect directly with locals ready to discover your deals. No commissions, no complexity—just results.
          </p>

          <div className="mt-8 lg:mt-12 flex justify-center lg:justify-start">
            <a
              href={SIGNUP_URL}
              className="rounded-full bg-white text-[#222] px-7 py-3.5 lg:px-8 lg:py-4 text-[15px] lg:text-[18px] font-medium shadow-[0_10px_25px_rgba(0,0,0,0.15)] hover:scale-105 transition"
            >
              Sign Up Now
            </a>
          </div>
        </div>

        {/* RIGHT */}
        <div className="relative flex justify-center lg:justify-end">
          <img
            src="/images/Webp/business/BusinessHeroDashboard.webp"
            alt="My Couponbook business dashboard on a tablet"
            className="relative w-full sm:w-[75%] lg:w-[100%] max-w-[1000px] lg:scale-[1.3] lg:origin-[60%_50%] drop-shadow-[0_40px_60px_rgba(0,0,0,0.45)]"
          />
          <div className="absolute right-0 sm:right-[4%] lg:right-[-8%] bottom-0 sm:bottom-[6%] lg:bottom-[2%] z-20 max-sm:scale-[0.7] max-sm:origin-bottom-right">
            <DealRedeemedCard />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes heroFloat { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-14px); } }
        .animate-heroFloat { animation: heroFloat 6s ease-in-out infinite; }
      `}</style>
    </section>
  );
};
